import { Helmet } from "react-helmet";

import { Box, Paper, Stack } from "@mui/material";

import useLayoutData from "@/hooks/useLayoutData";
import usePlatform from "@/hooks/usePlatform";

import Content from "./Content";
import { SignInCard } from "./SignInCard";

function SignIn() {
  const {isPc} = usePlatform();
  return (
    <Box className="grid w-screen transition-all place-items-center">
      <Helmet>
        <html lang="en" />
        <title>AwardTool | Sign in</title>
        <meta name="description" content="Sign in to save thousands and hours with AwardTool." />
      </Helmet>

      <Stack
        direction={{ xs: "column-reverse", md: "row" }}
        sx={{
          justifyContent: "center",
          gap: { xs: 6, sm: 5 },
          p: { xs: 2, sm: 10 },
          m: "auto",
          // mt:isPc?100:0,
        }}
      >
        <Content />
        <SignInCard />
      </Stack>
    </Box>
  );
}

export default SignIn;
